import { createSelector } from "reselect";

import { IBrandSampleSet } from "../../../Models/IBrandSampleSet";
import { IBrand } from "../../../Models/Models";
import { App } from "../Enums/App";
import { IRootReducer } from "../Reducers/RootReducer";
import { currentAppSelector } from "./AppSelectors";

export type BrandSampleSetInfo = {
    size: number;
    correlationId: number;
};

export const loadingBrandsSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.loadingBrands,
    (loading: boolean) => loading,
);

export const brandsSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.brands,
    (brands: IBrand[]) => brands,
);

export const brandsWithoutShoppingCentersSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.brands,
    brandsSelector,
    (brands: IBrand[]) => brands.filter(brand => !brand.isShoppingCenter),
);

export const brandSampleSetDataSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.sampleSet,
    currentAppSelector,
    brandsWithoutShoppingCentersSelector,
    (sampleSet: IBrandSampleSet[], app: App, nonShoppingCenterBrands: IBrand[]) => {
        if (app === App.Match) {
            return sampleSet.filter(location => nonShoppingCenterBrands.some(brand => brand.brandId === location.brandId));
        } else {
            return sampleSet;
        }
    }
);

export const loadingBrandSampleSetDataSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.loadingSampleSet,
    (loading: boolean) => loading,
);

export const brandSampleSetInfoSelector = createSelector(
    (state: IRootReducer) => state.brandsReducer.sampleSet,
    (state: IRootReducer) => state.brandsReducer.sampleSetCorrelationId,
    (sampleSet: IBrandSampleSet[], correlationId: number): BrandSampleSetInfo => ({
        size: sampleSet.length,
        correlationId,
    }),
);
